module.exports = __webpack_public_path__ + "gf.2fdc044faac7c3842155.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/gf.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/gf.svg
// module chunks = styles